module.exports = __webpack_public_path__ + "media/newstyle/images/icon-print-orange-edb0aa245358d745eb507cb290391fce.svg";